"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCertificates = exports.loadCertificate = void 0;
const api_1 = require("../api");
/**
 * Service to load a certificate, which receives the CSD in Base64 (POST)
 * @param endpoint URL to request data
 * @param json JSON of type CertificateRegister {b64Cer, b64Key, password, type	, is_active}
 * @param token Authentication bearer Token
 * @returns
 */
async function loadCertificate(endpoint, json) {
    try {
        const data = await api_1.api.postCertificate(endpoint, json);
        return data;
    }
    catch (error) {
        if (error.response) {
            // :: The request was made and the server responded with a status code
            return {
                data: error.response.data,
                status: error.response.status,
            };
        }
        else if (error.request) {
            // :: The request was made but no response was received
            return {
                data: error.request,
                status: '404',
            };
        }
        else {
            // :: Something happened in setting up the request that triggered an Error
            return {
                data: error.message,
                status: 'ERROR',
            };
        }
    }
}
exports.loadCertificate = loadCertificate;
/**
 * Service to consult all the certificates loaded in the account. (GET)
 * @param endpoint URL to request data
 * @param token Authentication bearer Token
 * @returns
 */
async function getCertificates(endpoint) {
    try {
        const data = await api_1.api.get(endpoint);
        console.log(data);
        return data;
    }
    catch (error) {
        if (error.response) {
            // :: The request was made and the server responded with a status code
            return {
                data: error.response.data,
                status: error.response.status,
            };
        }
        else if (error.request) {
            // :: The request was made but no response was received
            return {
                data: error.request,
                status: '404',
            };
        }
        else {
            // :: Something happened in setting up the request that triggered an Error
            return {
                data: error.message,
                status: 'ERROR',
            };
        }
    }
}
exports.getCertificates = getCertificates;
//# sourceMappingURL=certificateService.js.map